module.exports = __webpack_public_path__ + "3c5d909d524546b4553a9a6824b0f17d.png";